import { PaymentMethodEnum } from "types";

export const getPaymentMethodDisplayName = (
  method: PaymentMethodEnum,
  paymentMethod?: { card?: { last4?: string } }
): string => {
  switch (method) {
    case PaymentMethodEnum.Card:
      return paymentMethod?.card?.last4 
        ? `**** - ${paymentMethod.card.last4}` 
        : "Card";
    case PaymentMethodEnum.Cash:
      return "Cash";
    case PaymentMethodEnum.Venmo:
      return "Venmo";
    case PaymentMethodEnum.Check:
      return "Check";
    case PaymentMethodEnum.Wire:
      return "Wire";
    case PaymentMethodEnum.GenericCard:
      return "Credit Card";
    case PaymentMethodEnum.Zelle:
      return "Zelle";
    default:
      return "N/A";
  }
};

// Payment methods that are always available in dropdowns
export const PAYMENT_METHOD_OPTIONS = [
  { value: PaymentMethodEnum.Cash, label: "Cash" },
  { value: PaymentMethodEnum.Venmo, label: "Venmo" },
  { value: PaymentMethodEnum.Check, label: "Check" },
  { value: PaymentMethodEnum.Wire, label: "Wire" },
  { value: PaymentMethodEnum.Zelle, label: "Zelle" },
];
